/**
 * A common footer that is used by Angular 1.x apps with a map (for logged-in pages).
 * Currently used by Mapsure, MapExact, Content Tools, FleetView, and PCM Web UI.
 */

(function () {
  "use strict";

  angular
    .module("alk.maps")
    .directive("mapFooter", mapFooter);

  mapFooter.$inject = [];

  function mapFooter() {

    var directive = {
      template: require("./mapFooter.html"),
      controllerAs: "vm",
      controller: ["$scope", "$injector", "$rootScope", function ($scope, $injector, $rootScope) {
        var vm = this;
        vm.app = $scope.app;
        var UserProvider = $injector.get("UserProvider");
        vm.userInfo = UserProvider.getUser();

        vm.isProd = (process.env.ENV === "production");
        if (vm.userInfo.roles) {
          vm.isAdminOrSupport =
            vm.userInfo.roles.indexOf("ALK Administrator") !== -1 ||
            vm.userInfo.roles.indexOf("ALK Support") !== -1;
        }
        vm.userRoles = _.uniq(vm.userInfo.roles).toString();
        //If not showing the map, only need the copyright and TOS links
        if ($scope.mapShown !== "true") {
          return;
        }

        var mapService = $injector.get("mapService");


        //A bit hacky since the map services differ across apps, should refactor all apps to use same mapService eventually.
        if (vm.app === "PCMWebUI") {
          vm.mapObj = mapService.getMapFromId("pcmMap").map;
        } else {
          vm.mapObj = mapService.getMap();
        }

        $rootScope.$on("RegionUpdated", function() {
          vm.userInfo = UserProvider.getUser();
        });

      }],
      scope: {
        app: "@",
        mapShown: "@"
      }
    };

    return directive;
  }

})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/mapFooter.directive.js